import { WORLD_SEED } from "../config";

export function hashNumber(input: string): number {
  let h = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function getBiome(sectorX: number, sectorY: number): string {
  if (sectorX >= 6 && sectorY >= 4) return "Neural Reach";
  if (sectorX >= 4 && sectorX <= 5 && sectorY >= 4 && sectorY <= 5) return "Heartforge";
  if (sectorX >= 4 && sectorY <= 3) return "Veinworks";
  if (sectorX <= 3 && sectorY >= 4) return "Bone Gardens";
  return "Skinlands";
}

export function generateSector(sectorX: number, sectorY: number) {
  const sectorSeed = hashNumber(`${WORLD_SEED}:${sectorX}:${sectorY}`);
  return {
    sectorSeed,
    biome: getBiome(sectorX, sectorY),
    heightmapSize: 128,
    lod: [
      { distance: 50, triangles: 15000 },
      { distance: 200, triangles: 5000 },
      { distance: 800, billboard: true }
    ]
  };
}
